import { render, staticRenderFns } from "./AuthorityTypeEdit.vue?vue&type=template&id=2dbde192"
import script from "./AuthorityTypeEdit.vue?vue&type=script&lang=js"
export * from "./AuthorityTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports